import styled from "styled-components";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { useRef, useState } from "react";
import SearchAddrApi from "../../../User/Sign/Modal/SearchAddrApi";
import api from "../../../../Component/axios_Interceptor/api";
import url, { SERVER_ADDRESS } from "../../../../Component/server";
import api2 from "../../../../Component/axios_Interceptor/api2";

interface Step2Props {
  BUSName: string;
  handleBUSName: (e: React.ChangeEvent<HTMLInputElement>) => void;
  BUSPostCode: string;
  BUSFirAddr: string;
  BUSSecAddr: string;
  setBUSPostCode: React.Dispatch<React.SetStateAction<string>>;
  setBUSFirAddr: React.Dispatch<React.SetStateAction<string>>;
  handleSecAddr: (e: React.ChangeEvent<HTMLInputElement>) => void;
  BUSImage: string[];
  uploadBUSImage: (data: string) => void;
  delBUSImage: (data: string, index: number) => void;
}

const Step2 = ({
  BUSName,
  handleBUSName,
  BUSPostCode,
  BUSFirAddr,
  BUSSecAddr,
  setBUSPostCode,
  setBUSFirAddr,
  handleSecAddr,
  BUSImage,
  uploadBUSImage,
  delBUSImage,
}: Step2Props) => {
  const emailList = [
    "naver.com",
    "gmail.com",
    "hanmail.net",
    "daum.net",
    "직접입력",
  ];

  const openSearchAddr = () => {
    SearchAddrApi({ setFirAddr: setBUSFirAddr, setPostCode: setBUSPostCode });
  };

  // 사진 업로드
  const picPreviewRef = useRef<HTMLInputElement | null>(null);
  const insert_pic = () => {
    if (picPreviewRef && picPreviewRef.current) {
      picPreviewRef.current.click();
    }
  };

  const allowedExtensions = [".png", ".jpg", ".jpeg", ".pdf"];
  const renderPic = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const fileExtension = file.name.toLowerCase();

      if (!allowedExtensions.some((ext) => fileExtension.endsWith(ext))) {
        alert("png, jpg, jpge, pdf 파일만 첨부가능합니다.");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && typeof e.target.result === "string") {
          // uploadBUSImage(e.target.result);
          setting_pic(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const setting_pic = async (file: File) => {
    try {
      const res = await api2.post(
        url.Communication_url.upload_license,
        { file: file },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.message.includes("성공")) {
        uploadBUSImage(res.data.file_path);
      }
    } catch (error) {
      console.error("실패:", error);
    }
  };

  return (
    <>
      <Title>
        사업자명 <span style={{ color: "red" }}>*</span>
      </Title>
      <InsertDiv>
        <InsertInput
          type="text"
          placeholder="사업자명을 입력해주세요."
          value={BUSName}
          onChange={handleBUSName}
        />
      </InsertDiv>
      <Title>
        사업자 주소 <span style={{ color: "red" }}>*</span>
      </Title>
      <PostCodeDiv>
        <PostCodeInsertDiv>
          <PostCodeInsert
            disabled
            type="text"
            placeholder="우편번호"
            value={BUSPostCode}
          />
        </PostCodeInsertDiv>
        <PostCodeSearchBtn onClick={openSearchAddr}>검색</PostCodeSearchBtn>
      </PostCodeDiv>
      <InsertDiv>
        <InsertInput
          disabled
          type="text"
          placeholder="주소"
          value={BUSFirAddr}
        />
      </InsertDiv>
      <InsertDiv>
        <InsertInput
          type="text"
          placeholder="상세주소를 입력해주세요."
          value={BUSSecAddr}
          onChange={handleSecAddr}
        />
      </InsertDiv>
      <Title>
        사업자등록증 <span style={{ color: "red" }}>*</span>
      </Title>
      <ImageListDiv>
        {BUSImage.length === 0 && (
          <ImageDiv style={{ cursor: "pointer" }} onClick={insert_pic}>
            <Icon
              style={{ width: 24, height: 24 }}
              src={require("../../../../Image/ic_plus_gray.png")}
            />
          </ImageDiv>
        )}
        {BUSImage.map((item, index) => {
          return (
            <ImageDiv key={index}>
              <DelBtn
                src={require("../../../../Image/ic_x_circle_white.png")}
                onClick={() => {
                  delBUSImage(item, index);
                }}
              />
              <Image
                src={
                  item.includes(".pdf")
                    ? require("../../../../Image/ic_pdf.png")
                    : SERVER_ADDRESS + "openfile/" + item
                }
              />
            </ImageDiv>
          );
        })}
      </ImageListDiv>
      <input
        style={{ display: "none" }}
        ref={picPreviewRef}
        type="file"
        onChange={renderPic}
      />
    </>
  );
};

export default Step2;

const Title = styled.div`
  font-family: var(--font-Pretendard-Medium);
  margin-top: 30px;
`;

const InsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  width: 100%;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
  margin-top: 10px;
`;

const InsertInput = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 화살표 제거 - Firefox */
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

const PostCodeDiv = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const PostCodeInsertDiv = styled.div`
  flex-direction: row;
  display: flex;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  flex: 5;
  height: 50px;
  justify-self: center;
  align-items: center;
  justify-content: flex-start;
  padding: 12px;
  box-sizing: border-box;
`;

const PostCodeInsert = styled.input`
  margin-left: 4px;
  font-size: 16px;
  color: black;
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
`;

const PostCodeSearchBtn = styled.div`
  cursor: pointer;
  background-color: black;
  height: 48px;
  border-radius: 8px;
  flex: 1;
  margin-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  color: white;
`;

const ImageListDiv = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  max-width: 500px;
  overflow-x: auto;
  padding-top: 11px; // 버튼 여유 공간 확보
`;

const ImageDiv = styled.div`
  display: flex;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  width: 100px;
  height: 100px;
  margin-right: 16px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
`;

const Image = styled(Icon)`
  border-radius: 8px;
  width: 100px;
  height: 100px;
`;

const DelBtn = styled(Icon)`
  cursor: pointer;
  position: absolute;
  top: -12px;
  right: -12px;
`;
